<template>
    <v-container>
        <v-card v-if="!loading" class="rounded-lg mt-8" max-width="700" style="margin:auto;">
            <v-card-title>Accept Invitation</v-card-title>
            <v-card-text>
                <template v-if="show == 'invitation'">
                    <p>{{invitation.user_name}} has invited you to have access to their meeting room.</p>

                    <div class="font-weight-bold mt-8">Meeting Room Permissions</div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Room Name
                                    </th>
                                    <th class="text-center">
                                        Coach 
                                        <v-tooltip top max-width="300">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>Coaches can join meetings but can only be seen and heard by other coaches and hosts. Coaches are not seen or heard by guests in the meeting. Once permission is granted, they can enter any meeting at anytime in the specified room.</span>
                                        </v-tooltip>
                                    </th>
                                    <th class="text-center">
                                        QA (Quality Assurance)
                                        <v-tooltip top max-width="300">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>QAs can quietly log into meetings without being seen or heard by anyone - good for supervisors or those in training. Once permission is granted, they can enter any meeting at anytime in the specified room.</span>
                                        </v-tooltip>
                                    </th>
                                    <th class="text-center">
                                        Reports
                                        <v-tooltip top max-width="300">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>Grants access to room activity reports.</span>
                                        </v-tooltip>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="room in invitation.room_settings" :key="room.ID">
                                    <template v-if="room.can_coach || room.can_qa">
                                    <td>{{ room.name }}</td>
                                    <td class="text-center">
                                        <v-icon color="success" v-if="room.can_coach">mdi-check-circle</v-icon>
                                    </td>
                                    <td class="text-center">
                                        <v-icon color="success" v-if="room.can_qa">mdi-check-circle</v-icon>
                                    </td>
                                    <td class="text-center">
                                        <v-icon color="success" v-if="room.can_access_reports">mdi-check-circle</v-icon>
                                    </td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </template>

                <template v-if="show == 'register'">
                    <v-form ref="register_form" v-model="register_valid" lazy-validation>
                        <v-text-field label="First Name" v-model="invitation.first_name" outlined :rules="[rules.required]"></v-text-field>
                        <v-text-field label="Last Name" v-model="invitation.last_name" outlined :rules="[rules.required]"></v-text-field>
                        <v-text-field label="Email" v-model="invitation.email" outlined :rules="[rules.required, rules.email]"></v-text-field>
                        <v-text-field label="Password" v-model="password" outlined type="password" :rules="[rules.required, rules.password]"></v-text-field>
                        <v-text-field label="Confirm Password" v-model="password2" outlined type="password" :rules="[rules.required, rules.password, rules.password2]"></v-text-field>
                    </v-form>
                </template>

                <template v-if="show == 'login'">
                    <v-text-field label="email" v-model="user_login" outlined></v-text-field>
                    <v-text-field label="password" v-model="user_pass" outlined type="password"></v-text-field>
                </template>

            </v-card-text>
            <v-card-actions class="pa-4">
                <template v-if="show == 'invitation'">
                    <template v-if="!user.userdata.ID">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="continueBtn()">Continue</v-btn>
                    </template>
                    <template v-else>
                        <div style="font-size:.7em;" class="text--disabled">Logged in as {{user.userdata && user.userdata.data ? user.userdata.data.display_name : ''}}</div>
                        <v-btn x-small text class="ml-2" @click="app.logOut()">Log Out</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="accept()" :loading="accepting">Accept</v-btn>
                    </template>
                </template>

                <template v-if="show == 'register'">
                    Already have an account?
                    <v-btn text @click="show = 'login'" color="primary">Log In</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="register()" :loading="registering" >Register</v-btn>
                </template>

                <template v-if="show == 'login'">
                    <v-btn text @click="show = 'register'">Register</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="login()" :loading="logging_in">Log In</v-btn>
                </template>
            </v-card-actions>
        </v-card>
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
        </v-overlay>
        <!-- <v-btn color="primary" @click="test()">Test</v-btn> -->
    </v-container>
</template>

<script>
import { useAppStore } from '../stores/app'
import { useUserStore } from '../stores/user'

export default {
    name: 'Invitation',
    components: { },
    created: function() {
        this.app = useAppStore()
        this.user = useUserStore()
    },
    data: function() {
        return {
            app: null,
            user: null,
            loading: true,
            accepting: false,
            invitation: {},
            show: 'invitation',
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            password2: '',
            registering: false,
            logging_in: false,
            register_valid: true,
            user_login: '',
            user_pass: '',
            rules: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
                password: value => {
                    return value.length >= 8 || 'Must be at least 8 characters.'
                },
                password2: value => {
                    return value == this.password || "Doesn't match"
                }
            },
        }
    },
    mounted: function() {
        this.app.get(`meeting/invitation/${this.$route.params.id}`)
        .then( response => {
            this.invitation = response.data
            this.loading = false
        })
    },
    methods: {
        continueBtn: function() {
            if(!this.user.userdata.ID)
                this.show = 'register'
            else
                this.accept()
        },
        register: function() {
            
            let valid = this.$refs.register_form.validate()
            if(!valid)
                return

            this.registering = true
            const data = {
                first_name: this.invitation.first_name,
                last_name: this.invitation.last_name,
                user_email: this.invitation.email,
                user_pass: this.password,
                invitation: this.invitation,
                invitation_id: this.$route.params.id,
            }
            this.app.post('meeting/register', data)
                .then(response => {
                    if(response.data.error) {
                        this.registering = false
                        this.app.showError(response.data.error)
                    } else {
                        window.location.reload()
                    }
                })
                .catch(error => {
                    console.error(error)
                    this.app.showError("Oops! Something went wrong.")
                    this.registering = false
                })
        },
        login: function() {
            this.logging_in = true
            const data = {
                user_login: this.user_login,
                user_password: this.user_pass
            }
            this.app.post('meeting/login', data)
                .then(response => {
                    this.logging_in = false
                    if(response.data.errors) {
                        this.app.showError(response.errors.join('<br />'))
                    } else {
                        // this.user.userdata.ID = response.data.ID
                        // this.user.userdata.data = response.data.data
                        // this.show = 'invitation'
                        window.location.reload()
                    }
                })
                .catch(error => {
                    console.error(error)
                    this.app.showError("Oops! Something went wrong.")
                    this.logging_in = false
                })
        },
        accept: function() {
            this.accepting = true
            this.invitation.id = this.$route.params.id
            this.app.post('meeting/accept-invitation', this.invitation)
                .then(response => {
                    this.accepting = false
                    if(response.data.errors) {
                        this.app.showError(response.errors.join('<br />'))
                    } else {
                        // this.user.userdata.ID = response.data.ID
                        // this.show = 'invitation'
                        this.$router.push({path:'/admin/roles'})
                    }
                })
                .catch(error => {
                    console.error(error)
                    this.app.showError("Oops! Something went wrong.")
                    this.accepting = false
                })
        },
    },
    watch: {
        'user.userdata': {
            handler(newV) {
                console.log('watch user.userdata', newV)
            },
            deep: true
        }
    }

}
</script>

